import { Form, Input, InputNumber, Select, Spin } from 'antd'
import FormItem from 'antd/es/form/FormItem'
import { OperationBean } from 'common/api/api.ts'
import { AnchorsForm } from 'common/components/AnchorsForm.tsx'
import { ButtonsPanel } from 'common/components/ButtonsPanel.tsx'
import { FormCard } from 'common/components/FormCard.tsx'
import { AdvertiserSelector } from 'common/components/reloadable/AdvertiserSelector.tsx'
import { useAppContext } from 'common/context/AppContext.tsx'
import { apiCall } from 'common/util/Util.tsx'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { balanceApi } from 'common/api/entitiesApi.tsx'

type FormShape = {
  advertiserId?: number
  operationType: OperationBean.OperationTypeEnum
  amount: number
  note?: string
}

const TransactionForm: React.FC = () => {
  const navigateTo = useNavigate()
  const appContext = useAppContext()
  const { id } = useParams<{ id: string }>()

  const [form] = Form.useForm<FormShape>()
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    const defaults: Partial<FormShape> = {
      advertiserId: id ? Number(id) : undefined,
      operationType: OperationBean.OperationTypeEnum.ADD,
    }
    form.setFieldsValue(defaults as any)
  }, [id])

  const handleSubmit = () => {
    setLoading(true)
    form
      .validateFields()
      .then((values) =>
        apiCall(setLoading, appContext, () => balanceApi.balanceOperate(values as OperationBean), onCancel),
      )
  }

  function onCancel() {
    navigateTo(id ? '/adv' : '/transactions')
  }

  return (
    <Spin spinning={loading}>
      <AnchorsForm form={form} onFinish={handleSubmit}>
        <FormCard id="general" title="General">
          <FormItem
            name="advertiserId"
            rules={[{ required: true, message: 'Advertiser is required' }]}
            label="Advertiser"
          >
            <AdvertiserSelector placeholder="Select advertiser" />
          </FormItem>

          <FormItem name="operationType" rules={[{ required: true, message: 'Choose operation' }]} label="Operation">
            <Select
              options={[
                { label: 'Add money', value: OperationBean.OperationTypeEnum.ADD },
                { label: 'Subtract money', value: OperationBean.OperationTypeEnum.SUBTRACT },
              ]}
              placeholder="Select Operation"
            />
          </FormItem>

          <FormItem
            name="amount"
            rules={[
              { required: true, message: 'Please input amount of money', type: 'number' },
              { message: 'Amount of money should be positive', type: 'number', min: 0.01 },
            ]}
            label="Amount"
          >
            <InputNumber min={0.01} style={{ width: 200 }} suffix="$" />
          </FormItem>

          <FormItem
            name="note"
            rules={[
              {
                required: false,
                max: 1000,
                type: 'string',
                message: 'Note should be less than 1000 symbols',
              },
            ]}
            label="Note for Advertiser"
          >
            <Input placeholder="Optional note" />
          </FormItem>
        </FormCard>

        <ButtonsPanel onCancel={onCancel} />
      </AnchorsForm>
    </Spin>
  )
}

export default TransactionForm
